import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as DossierOpenSearchObjectGroupParameters,
    Configuration,
    DossierOpenSearchApi,
    ObjectGroupsApi,
    ObjectGroupsApiApiObjectGroupsIdGetRequest,
} from '../../../openApi/ApiFormalite';
import {
    DOSSIERS_OPEN_SEARCH_OBJECT_GROUP_SLICE_NAME,
    FORMALITES_REDUCER_NAME,
} from '../constants';
import { DossierObjectGroup } from './dossierObjectGroupSlice';

export const mapperDossierOpenSearchObjectGroups = function (objectGroup: DossierObjectGroup) {
    return {
        ...objectGroup,
    } as DossierObjectGroup;
};

export function createDossierOpenSearchObjectGroupSlice(
    configuration: DossierOpenSearchObjectGroupParameters,
) {
    const conf = new Configuration(configuration);
    const api = new DossierOpenSearchApi(conf);

    const fetchOpenSearchDossierObjectGroupsCollection: FetchCollectionData<DossierObjectGroup> = ({
        pagination,
        filters,
    }) => {
        let term: undefined | string;
        let groupId: undefined | number[];
        if (filters && filters.label) {
            term = filters.label as string;
        }
        if (filters && filters.groupId) {
            groupId = [filters.groupId as number];
        }
        const options = undefined;
        const requestParameters = {
            page: pagination.page + 1,
            itemsPerPage: pagination.itemsPerPage,
            q: term,
            groupId,
        };

        return api
            .apiOpensearchObjectGroupsGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<DossierObjectGroup>>;
    };

    const apiObjectGroup = new ObjectGroupsApi(conf);
    const fetchDossierObjectGroupItem: FetchItemDataType<DossierObjectGroup> = ({ idItem }) => {
        const requestParameters: ObjectGroupsApiApiObjectGroupsIdGetRequest = {
            id: String(idItem),
        };

        return apiObjectGroup
            .apiObjectGroupsIdGet(requestParameters)
            .then((res) => res.data) as Promise<DossierObjectGroup>;
    };

    const {
        slice: dossierOpenSearchObjectGroupSlice,
        dataSourcesThunks: dossierOpenSearchObjectGroupDataSourcesThunks,
    } = SliceFactory.createSlice<DossierObjectGroup, DossierObjectGroup>(
        DOSSIERS_OPEN_SEARCH_OBJECT_GROUP_SLICE_NAME,
        FORMALITES_REDUCER_NAME,
        [],
        fetchOpenSearchDossierObjectGroupsCollection,
        fetchDossierObjectGroupItem,
        mapperDossierOpenSearchObjectGroups,
        {},
        undefined,
    );

    return { dossierOpenSearchObjectGroupSlice, dossierOpenSearchObjectGroupDataSourcesThunks };
}
